/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TimeWorkedResponse } from '../models/TimeWorkedResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TimeWorkedService {
    /**
     * returns time worked for current employee
     * @returns TimeWorkedResponse successful
     * @throws ApiError
     */
    public static getMyTimeWorked(): CancelablePromise<TimeWorkedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/time_management/time_tracking/time_worked/me',
        });
    }
}
